import { ComponentVariantChangeModel } from './component-variant-change';
import { ConfigurationModel } from './configuration';

export class ChangeModel {
    constructor(variantChange: Array<ComponentVariantChangeModel>, configurationChange: ConfigurationModel) {
        this.VariantChanges = variantChange;
        this.ConfigurationChange = configurationChange;

    }

    public VariantChanges: Array<ComponentVariantChangeModel>;
    public ConfigurationChange: ConfigurationModel;
}
